import {Component, forwardRef, OnInit} from '@angular/core';
import {ModelService} from '../../../../Services/model.service';
import {StartAction} from '../../../../Model/Dto/StartAction';
import {UserActionBaseComponent} from '../userAction-base.component';
import {Customer} from '../../../../Model/User/Customer';
import {Catalog} from '../../../../Model/Catalog/Catalog';
import {TranslateService} from '@ngx-translate/core';
import {CatalogService} from 'app/Services/CatalogManagement/catalog.service';
import {MacroService} from 'app/Services/CatalogManagement/macro.service';
import {JobService} from 'app/Services/job.service';
import {LoginService} from 'app/Services/login.service';
import {Macro} from 'app/Model/ui/Macro';
import {FeatureSystem} from "../../../../Model/Catalog/FeatureModels/FeatureSystem";
import {ValidFeatureService} from "../../../../Services/validFeature.service";
import {ValidFeatureSystem} from "../../../../Model/ValidFeatureSystem";
import {firstValueFrom} from "rxjs";

@Component({
  selector: 'userAction-copyFeatureSystem',
  templateUrl: 'userAction-copyFeatureSystem.component.html',
  providers: [
    {provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionCopyFeatureSystemComponent)}
  ],
  standalone: false
})
export class UserActionCopyFeatureSystemComponent extends UserActionBaseComponent implements OnInit {

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public featureSystemService: ValidFeatureService
  ) {
    super(loginService, macroService);
  }

  async ngOnInit(): Promise<void> {
    this.featureSystemLoded = false;
    super.ngOnInit();
    this.featureSystems = await this.loadUniqueFeatureSystemsInCatalog();
  }

  featureSystems: ValidFeatureSystem[] = [];
  selectedFeatureSystemToCopy: string;
  newNameForFeatureSystem: string;
  selectedCatalogId: string;
  featureSystemLoded:boolean;
  public async canStartMacro(): Promise<boolean> {
    if (this.newNameForFeatureSystem == null || this.newNameForFeatureSystem == "") {
      return false;
    }
    if (this.selectedFeatureSystemToCopy == "" || this.selectedFeatureSystemToCopy == null) {
      return false;
    }

    return true;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({
      FeatureSystemToCopyId: this.selectedFeatureSystemToCopy,
      NewFeatureSystemName: this.newNameForFeatureSystem,
      UsedCatalogId: this.catalogService.catalog.id
    });
  }

  public async loadUniqueFeatureSystemsInCatalog(): Promise<ValidFeatureSystem[]> {

    var fsInCatalog = await firstValueFrom(this.featureSystemService.getCatalogSystems(this.catalogService.catalog.id, this.loginService.currentCustomer.id));
    const uniqueFs = fsInCatalog.filter((item, index, self) =>
      index === self.findIndex((t) => t.id === item.id)
    );

    this.featureSystemLoded = true;
    return uniqueFs;
  }

  parseParameter(parameter: string) {
    if (!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.newNameForFeatureSystem = parsed.NewFeatureSystemName;
      this.selectedFeatureSystemToCopy = parsed.FeatureSystemToCopyId;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
